// useFakeProgress.js
import { useEffect, useRef, useState } from 'react';

export const useFakeProgress = ({ max = 95, duration = 30000 } = {}) => {
  const [progress, setProgress] = useState(0);
  const intervalRef = useRef(null);

  const clear = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };

  const start = () => {
    clear();
    setProgress(0);
    const stepTime = duration / max;

    intervalRef.current = setInterval(() => {
      setProgress((prev) => {
        if (prev < max) return prev + 1;
        clear();
        return prev;
      });
    }, stepTime);
  };

  const finish = () => {
    clear();
    setProgress(100);
  };

  const reset = () => {
    clear();
    setProgress(0);
  };

  useEffect(() => () => clear(), []);

  return { progress, start, finish, reset };
};
